/* eslint-disable no-undef */
import { memo, useContext, useEffect, useState } from "react";
import Axios from "axios";
import { Col, Form } from "react-bootstrap";
import DashboardContext from "../../../Context";
import InputPricing from "../../../components/inputs/InputPricing";
import NumberFormat from 'react-number-format';

const AmountPerHourInfo = ({
  groupId,
  dataUpdate,
  handelPutData,
  periodTime,
  startWork,
  editMode,
  setOffEditMode,
}) => {
  const {
    authentication,
    urldashboard,
    handelerrors,
    urlpatch,
    setNewPeriodTime,
  } = useContext(DashboardContext);

  const [dataFech, setDataFech] = useState({});

  const [Loading, setLoading] = useState(true);
  const dataFeching = async () => {

    setLoading(true);
    try {
      const res = await Axios.post(
        `${urldashboard}/order/CalculateCustomAmount`,
        JSON.stringify({
          groupId,
          customHour: periodTime,
          startWork: startWork,
          
        }),
        {
          headers: {
            Authorization: authentication,
            "Content-Type": "application/json; charset=utf-8 ",
          },
        }
      );

      handelPutData(res.data.data);
      const data = await res.data.data;

      setDataFech(data);
      setLoading(false);
    } catch (error) {
      handelerrors(error);
      setDataFech({});
      setLoading(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    if (
      dataUpdate.customAmountFemaleWorker ||
      dataUpdate.customAmountMaleWorker
    ) {
      setDataFech({
        maleAmountPerHour: dataUpdate.customAmountMaleWorker ?? 0,
        femaleAmountPerHour: dataUpdate.customAmountFemaleWorker ?? 0,
      });
      setLoading(false);
    }

    if (editMode) {
      setOffEditMode(false);
    } else {
      dataFeching();
    }
    setOffEditMode(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupId, periodTime]);

  const handelValue = (name, value) => {
    handelPutData({ [name]: value });
  };

  return (
    <>
      {Loading ? (
        <i className="fa-li fa fa-spinner fa-spin"></i>
      ) : dataFech.maleAmountPerHour !== undefined || dataFech.femaleAmountPerHour !== undefined ? (


        <>
          <Col style={{marginTop:10}} lg="3" md="3" sm="12" xs="12">
            <div> هزینه نیروآقا ساعتی
              <NumberFormat
                thousandSeparator={','}
                disabled={true}
                autoComplete={"off"}
                defaultValue={dataFech.maleAmountPerHour}
                decimalSeparator={'-'}
                dir='ltr'
                style={{ height: '50px', width: '100%', border: 'none !important' }} />
            </div>
          </Col>

          <Col style={{marginTop:10}} lg="3" md="3" sm="12" xs="12">
            <div> هزینه نیرو خانم ساعتی
              <NumberFormat
                thousandSeparator={','}
                disabled={true}
                autoComplete={"off"}
                defaultValue={dataFech.femaleAmountPerHour}
                decimalSeparator={'-'}
                dir='ltr'
                style={{ height: '50px', width: '100%', border: 'none !important' }} />
            </div>
          </Col>
        </>








        // <Col lg="9" md="9" sm="12" xs="12">
        //   <Form.Row>
        //     <Col lg="6" md="6" sm="12" xs="12">
        //       <InputPricing
        //         label="هزینه نیرو آقا ساعتی"
        //         name="customAmountMaleWorker"
        //         handelValue={handelValue}
        //         defaultValue={dataFech.maleAmountPerHour}
        //       />
        //     </Col>
        //     <Col lg="6" md="6" sm="12" xs="12">
        //       <InputPricing
        //         label="هزینه نیرو خانم ساعتی"
        //         name="customAmountFemaleWorker"
        //         handelValue={handelValue}
        //         defaultValue={dataFech.femaleAmountPerHour}
        //       />
        //     </Col>
        //   </Form.Row>
        // </Col>
      ) : null}
    </>
  );
};

// export default memo(AmountPerHourInfo)

export default memo(AmountPerHourInfo);
